// extracted by mini-css-extract-plugin
module.exports = {"navigationMenuLink":"styles-module__navigationMenuLink___2bJCv","navigationMenu":"styles-module__navigationMenu___1UiYh"};